<template>
  <div class="page">
    <!-- 我的 start -->
    <div v-if="userInfo" class="mineTop">
      <div class="picWap">
        <el-image class="img mach-height mach-width" :src="userInfo.avatar" fit="cover">
          <div slot="error" class="image-slot flex flex-center">
            <img class="default-img" src="../../../../assets/icon-user-default.png">
          </div>
        </el-image>
      </div>
      <h3 class="name">{{ userInfo.name }}</h3>
      <div class="subTit">发布 {{ userInfo.collectionNumber }} 馆藏</div>
    </div>
    <!-- 我的 end -->

    <!-- 跳转导航 start -->
    <div class="naviLink">
      <router-link class="itm" :to="{ name: 'Wapuserupload' }">
        <img src="../../../../images/icon-up.png">
        <span>我的上传</span>
        <img src="../../../../images/icon-next.png" class="icon-next">
      </router-link>
      <router-link class="itm" :to="{ name: 'Wapusercollection' }">
        <img src="../../../../images/icon-coll.png">
        <span>我的收藏</span>
        <img src="../../../../images/icon-next.png" class="icon-next">
      </router-link>
    </div>
    <div class="naviLink">
      <div class="itm" data-type="feedback" @click="goProfilePage">
        <img src="../../../../images/icon-fk.png">
        <span>咨询与反馈</span>
        <img src="../../../../images/icon-next.png" class="icon-next">
      </div>
      <div class="itm" data-type="potocal" @click="goProfilePage">
        <img src="../../../../images/icon-agree.png">
        <span>服务使用协议</span>
        <img src="../../../../images/icon-next.png" class="icon-next">
      </div>
      <div class="itm" data-type="secret" @click="goProfilePage">
        <img src="../../../../images/icon-privacy.png">
        <span>个人信息保护政策</span>
        <img src="../../../../images/icon-next.png" class="icon-next">
      </div>
      <div class="itm" data-type="contact" @click="goProfilePage">
        <img src="../../../../images/icon-link.png">
        <span>联系我们</span>
        <img src="../../../../images/icon-next.png" class="icon-next">
      </div>
    </div>

    <div class="logout" @click="logout">
      <p>退出登录</p>
    </div>
    <!-- 跳转导航 end -->

    <!-- 导航 start -->
    <div class="naviPosition" />
    <div class="digNavigate">
      <router-link class="navItm" :to="{ name: 'Waphome' }">
        <img src="../../../../images/home.png" class="img-normal">
        <img src="../../../../images/home_select.png" class="img-active">
        <label>首页</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Waplist' }">
        <img src="../../../../images/res.png" class="img-normal">
        <img src="../../../../images/res_select.png" class="img-active">
        <label>{{clients.collectionTheme?clients.collectionTheme:'特藏'}}</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapcertified' }">
        <img src="../../../../images/upload.jpg" class="img-normal">
        <img src="../../../../images/upload_select.jpg" class="img-active">
        <label>上传</label>
      </router-link>
      <router-link class="navItm active" :to="{ name: 'Wapuser' }">
        <img src="../../../../images/use.png" class="img-normal">
        <img src="../../../../images/use_select.png" class="img-active">
        <label>我的</label>
      </router-link>
    </div>
    <!-- 导航 end -->
  </div>
</template>

<script>
import userdata from '../../../../models/user.js'
// import userapi from '../../../../api/userpage.js'
import api from '../../../../api/auth.js'
import auth from '../../../../models/auth.js'
import homeapi from '@/api/home.js'
export default {
  name: 'Wapuser',
  data() {
    return {
      userInfo: null,
      clients:{}
    }
  },
  created() {
    this.requestUser()
    this.requestclient();
  },

  methods: {
    //获取应用信息
        requestclient() {
        const that = this;
        homeapi
            .requestclient({ tenantId: this.$store.getters.tenantId })
            .then(r => {
            that.clients = r.data;
            })
            .catch(err => {
            console.log(err);
            });
        },
    requestUser() {
      if (auth.gettoken()) {
        const that = this
        api.userInfo().then(r => {
          that.userInfo = r.data
          userdata.save(r.data)
        })
      } else {
        this.$router.replace({
          path: '/wap/login',
          query: {
            r: '/wap/user'
          }
        })
      }
    },
    goProfilePage(e) { // 跳转到静态页面
      const t = e.currentTarget.dataset.type
      this.$router.push({
        name: 'Wapprofile',
        query: {
          t: t
        }
      })
    },
    logout() {
      this.$store.dispatch('user/logout')
      userdata.clean()
      this.$router.push({
        path: '/wap'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
 ::v-deep .el-image__inner {
   border-radius: 50%;
  }
</style>

<style src="@/styles/wap.scss" lang="scss" scoped></style>
<style scoped>

.page {
  padding-bottom: 1rem;
}
 .img {
   border-radius: 50%;
 }

 .logout {
   width: 100%;
   display: flex;
   align-items: center;
   justify-content: center;
   margin-top: 3rem;
 }

 .logout p {
   font-size: 0.44rem;
   color: #264480;
 }

 .default-img {
   border-radius: 50%;
 }
</style>
